import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { formatNumber, formatNumberToB, formatNumber_N1, formatNumberToB_N1, priceToNumber} from '../../helpers/utils';

export default memo(function IDXSumary(props) {
    const { indexCode } = props;

    const {t} = useTranslation();

    const i_counter = useSelector(state => state.gIndex.indexInfos.find(item => item.indexCode === indexCode)?.counter);
    const indexInfo = useSelector(state => state.gIndex.indexInfos.find(item => item.indexCode === indexCode)) ?? {};

    //
    return (
        <>
            <div className="titletabs text-uppercase">{t("tongQuan")}</div>
            <table className="tabletabs">
                <tbody>
                    <tr>
                        <td>{t("thamChieu")}</td>
                        <td className="text-right"><span className="cl_yl font-weight-500">{formatNumber(indexInfo.priorIndex)}</span></td>
                    </tr>
                    <tr>
                        <td>{t("moCua")} - {t("dongCua")}</td>
                        <td className={clsx("text-right")}>
                            <span className={"font-weight-500 " + (indexInfo.openIndex_color ?? '')}>{formatNumber(indexInfo.openIndex)}</span>
                            <span> - </span>
                            <span className={"font-weight-500 " + (indexInfo.closeIndex_color ?? '')}>{formatNumber(indexInfo.closeIndex)}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>{t("thap")} - {t("cao")}</td>
                        <td className="text-right">
                            <span className={"font-weight-500 " + (indexInfo.lowestIndex_color ?? '')}>{formatNumber(indexInfo.lowestIndex)}</span>
                            <span> - </span>
                            <span className={"font-weight-500 " + (indexInfo.highestIndex_color ?? '')}>{formatNumber(indexInfo.highestIndex)}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div className="titletabs text-uppercase">{t("giaoDich")}</div>
            <table className="tabletabs">
                <tbody>
                    <tr>
                        <td className='text-left' style={{width: '33%'}}>{t("klKhopLenh")}</td>
                        <td className='text-left' style={{width: '33%'}}>{t("klThoaThuan")}</td>
                        <td className='text-left'>{t("tongKL")}</td>
                    </tr>
                    <tr>
                        <td className="text-left">{formatNumber_N1(indexInfo.totalTradedQttyNM)}</td>
                        <td className="text-left">{formatNumber_N1(indexInfo.totalTradedQttyPT)}</td>
                        <td className={clsx('text-left')}>{formatNumber_N1(indexInfo.totalTradedQtty)}</td>
                    </tr>
                    <tr>
                        <td className='text-left'>{t("gtKhopLenh")}</td>
                        <td className='text-left'>{t("gtThoaThuan")}</td>
                        <td className='text-left'>{t("tongGT")}</td>
                    </tr>
                    <tr>
                        <td className="text-left">{formatNumberToB_N1(indexInfo.totalTradedValueNM)} {indexInfo.totalTradedValueNM && indexInfo.totalTradedValueNM != 0 ? t('ty') : ''}</td>
                        <td className="text-left">{formatNumberToB_N1(indexInfo.totalTradedValuePT)} {indexInfo.totalTradedValuePT && indexInfo.totalTradedValuePT != 0 ? t('ty') : ''}</td>
                        <td className={clsx('text-left')}>{formatNumberToB_N1(indexInfo.totalTradedValue)} {indexInfo.totalTradedValue && indexInfo.totalTradedValue != 0 ? t('ty') : ''}</td>
                    </tr>
                </tbody>
            </table>
            <div className="titletabs text-uppercase">{t("gdNDTNN")}</div>
            <table className="tabletabs">
                <tbody>
                    <tr>
                        <td className='text-left' style={{width: '33%'}}>{t("klMua")}</td>
                        <td className='text-left' style={{width: '33%'}}>{t("klBan")}</td>
                        <td className='text-left'>{t("klRong")}</td>
                    </tr>
                    <tr>
                        <td className="text-left cl_gr">{formatNumber_N1(indexInfo.buyForeignQtty)}</td>
                        <td className="text-left cl_r">{formatNumber_N1(indexInfo.sellForeignQtty)}</td>
                        <td className={clsx('text-left', (priceToNumber(indexInfo.subForeignQtty) > 0 ? "cl_gr" : priceToNumber(indexInfo.subForeignQtty) < 0 ? "cl_r" : ''))}>{formatNumber_N1(indexInfo.subForeignQtty)}</td>
                    </tr>
                    <tr>
                        <td className='text-left'>{t("gtMua")}</td>
                        <td className='text-left'>{t("gtBan")}</td>
                        <td className='text-left'>{t("gtRong")}</td>
                    </tr>
                    <tr>
                        <td className="text-left cl_gr">{formatNumberToB_N1(indexInfo.buyForeignValue)} {indexInfo.buyForeignValue && indexInfo.buyForeignValue != 0 ? t('ty') : ''}</td>
                        <td className="text-left cl_r">{formatNumberToB_N1(indexInfo.sellForeignValue)} {indexInfo.sellForeignValue && indexInfo.sellForeignValue != 0 ? t('ty') : ''}</td>
                        <td className={clsx('text-left', (priceToNumber(indexInfo.subForeignValue) > 0 ? "cl_gr" : priceToNumber(indexInfo.subForeignValue) < 0 ? "cl_r" : ''))}>{formatNumberToB_N1(indexInfo.subForeignValue)} {indexInfo.subForeignValue && indexInfo.subForeignValue != 0 ? t('ty') : ''}</td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}, (prevProps, nextProps) => {
    if (prevProps.indexCode === nextProps.indexCode) {
        return true;
    }
    return false;
})

//
export const IDXSumaryPopup =  memo((props) => {
    const { indexCode } = props;

    const {t} = useTranslation();

    const i_counter = useSelector(state => state.gIndex.indexInfos.find(item => item.indexCode === indexCode)?.counter);
    const indexInfo = useSelector(state => state.gIndex.indexInfos.find(item => item.indexCode === indexCode)) ?? {};

    //
    return (
        <>
            <div className="titletabs text-uppercase">{t("tongQuan")}</div>
            <table className="tabletabs">
                <tbody>
                    <tr>
                        <td>{t("thamChieu")}</td>
                        <td colSpan={2} className="text-right"><span className="cl_yl font-weight-500">{formatNumber(indexInfo.priorIndex)}</span></td>
                    </tr>
                    <tr>
                        <td>{t("moCua")} - {t("dongCua")}</td>
                        <td colSpan={2} className={clsx("text-right")}>
                            <span className={"font-weight-500 " + (indexInfo.openIndex_color ?? '')}>{formatNumber(indexInfo.openIndex)}</span>
                            <span> - </span>
                            <span className={"font-weight-500 " + (indexInfo.closeIndex_color ?? '')}>{formatNumber(indexInfo.closeIndex)}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>{t("thap")} - {t("cao")}</td>
                        <td colSpan={2} className="text-right">
                            <span className={"font-weight-500 " + (indexInfo.lowestIndex_color ?? '')}>{formatNumber(indexInfo.lowestIndex)}</span>
                            <span> - </span>
                            <span className={"font-weight-500 " + (indexInfo.highestIndex_color ?? '')}>{formatNumber(indexInfo.highestIndex)}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='text-left' style={{width: '33%'}}>{t("klKhopLenh")}</td>
                        <td className='text-left' style={{width: '33%'}}>{t("klThoaThuan")}</td>
                        <td className='text-left'>{t("tongKL")}</td>
                    </tr>
                    <tr>
                        <td className="text-left">{formatNumber_N1(indexInfo.totalTradedQttyNM)}</td>
                        <td className="text-left">{formatNumber_N1(indexInfo.totalTradedQttyPT)}</td>
                        <td className={clsx('text-left')}>{formatNumber_N1(indexInfo.totalTradedQtty)}</td>
                    </tr>
                    <tr>
                        <td className='text-left'>{t("gtKhopLenh")}</td>
                        <td className='text-left'>{t("gtThoaThuan")}</td>
                        <td className='text-left'>{t("tongGT")}</td>
                    </tr>
                    <tr>
                        <td className="text-left">{formatNumberToB_N1(indexInfo.totalTradedValueNM)} {indexInfo.totalTradedValueNM && indexInfo.totalTradedValueNM != 0 ? t('ty') : ''}</td>
                        <td className="text-left">{formatNumberToB_N1(indexInfo.totalTradedValuePT)} {indexInfo.totalTradedValuePT && indexInfo.totalTradedValuePT != 0 ? t('ty') : ''}</td>
                        <td className={clsx('text-left')}>{formatNumberToB_N1(indexInfo.totalTradedValue)} {indexInfo.totalTradedValue && indexInfo.totalTradedValue != 0 ? t('ty') : ''}</td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}, (prevProps, nextProps) => {
    if (prevProps.indexCode === nextProps.indexCode) {
        return true;
    }
    return false;
})